export interface FormErrors {
  cpf?: string;
  name?: string;
  email?: string;
  phone?: string;
  birthDate?: string;
  gender?: string;
  pixKey?: string;
  addressPostalCode?: string;
  addressStreet?: string;
  addressNumber?: string;
  addressNeighborhood?: string;
  addressCity?: string;
  addressState?: string;
  hasExperience?: string;
  experienceTypes?: string;
  hasPreppoCertificate?: string;
  preppoCertificateLink?: string;
  agreeToTerms?: string;
}

export interface GenericEntity {
  id: number;
}

export interface EditStateType {
  cpf: string;
  name: string;
  fathersName: string;
  mothersName: string;
  email: string;
  phone: string;
  birthDate: string;
  gender: string;
  pixKey: string;
}

export interface StateType {
  cpf: string;
  name: string;
  fathersName: string;
  mothersName: string;
  email: string;
  phone: string;
  birthDate: string;
  gender: string;
  hasExperience: boolean;
  hearingTypes: GenericEntity[];
  hasPreppoCertificate: boolean;
  preppoCertificateLink: string;
  cvLink: string;
  portfolio: string;
  status: string;
  pixKey: string;
  address: {
    id?: number | null;
    postalCode: string;
    street: string;
    number: string;
    additionalAddressInfo: string;
    neighborhood: string;
    city: string;
    state: string;
    cityEntity?: { id: number } | null;
  };
  bankAccount: {
    bankAccountType: string;
    bankCode: string;
    agency: string;
    accountNumber: string;
  };
  citiesCovered: GenericEntity[];
  cityZonesCovered: GenericEntity[];
  availabilityModality: string;
  availability: {
    id?: number;
    mondayMorning: boolean;
    mondayAfternoon: boolean;
    tuesdayMorning: boolean;
    tuesdayAfternoon: boolean;
    wednesdayMorning: boolean;
    wednesdayAfternoon: boolean;
    thursdayMorning: boolean;
    thursdayAfternoon: boolean;
    fridayMorning: boolean;
    fridayAfternoon: boolean;
  };
  acceptedTermsDate: Date;
  agreeToTerms: boolean;
  agreeToTechnicalRequirements: boolean;
  acceptedTermsIp: string;
}

export interface AgentFormProps {
  agent: any | null;
}

export const emptyStateAgentForm: StateType = {
  cpf: "",
  name: "",
  fathersName: "",
  mothersName: "",
  email: "",
  phone: "",
  birthDate: "",
  gender: "",
  hasExperience: false,
  hearingTypes: [],
  hasPreppoCertificate: false,
  preppoCertificateLink: "",
  cvLink: "",
  portfolio: "",
  status: "",
  pixKey: "",
  address: {
    id: null,
    postalCode: "",
    street: "",
    number: "",
    additionalAddressInfo: "",
    neighborhood: "",
    city: "",
    state: "",
    cityEntity: null,
  },
  bankAccount: {
    bankAccountType: "",
    bankCode: "",
    agency: "",
    accountNumber: "",
  },
  citiesCovered: [],
  cityZonesCovered: [],
  availabilityModality: "3",
  availability: {
    mondayMorning: true,
    mondayAfternoon: true,
    tuesdayMorning: true,
    tuesdayAfternoon: true,
    wednesdayMorning: true,
    wednesdayAfternoon: true,
    thursdayMorning: true,
    thursdayAfternoon: true,
    fridayMorning: true,
    fridayAfternoon: true,
  },
  acceptedTermsDate: new Date(),
  agreeToTerms: false,
  agreeToTechnicalRequirements: false,
  acceptedTermsIp: "",
};
